import axios from 'axios';
import settings from '../settings';

export function loadInitialData() {
  return dispatch => Promise.all([
    axios.get(settings.contentUrl),
    axios.get(settings.projectListingsUrl),
  ]).then(([content, projectListings]) => {
    dispatch({
      type: 'INITIALIZED',
      content: content.data,
      projectListings: projectListings.data,
    });
  }).catch((err) => {
    dispatch({
      type: 'ERROR',
      content: err,
    });
  });
}

export function loadProjects(tag) {
  const path = settings.projectsUrl.replace('{tag}', tag);

  return dispatch => axios.get(path)
    .then((response) => {
      dispatch({
        type: 'PROJECTS_LOADED',
        tag,
        projects: response.data.nodes,
      });
    }).catch((err) => {
      dispatch({
        type: 'ERROR',
        content: err,
      });
    });
}

export function loadProject(slug) {
  const path = settings.projectUrl.replace('{slug}', slug);

  return dispatch => axios.get(path)
    .then((response) => {
      dispatch({
        type: 'PROJECT_LOADED',
        project: response.data,
      });
    }).catch((err) => {
      dispatch({
        type: 'ERROR',
        content: err,
      });
    });
}

export function loadPage(slug) {
  const path = settings.pageUrl.replace('{slug}', slug);

  return dispatch => axios.get(path)
    .then((response) => {
      dispatch({
        type: 'PAGE_LOADED',
        page: response.data,
      });
    }).catch((err) => {
      dispatch({
        type: 'ERROR',
        content: err,
      });
    });
}

export function toggleMenu(show = null) {
  return {
    type: 'TOGGLE_MENU',
    show,
  };
}

export function setPageTitle(title = '') {
  return {
    type: 'PAGE_TITLE',
    title,
  };
}

export function showLightbox(image) {
  return {
    type: 'SHOW_LIGHTBOX',
    image,
  };
}



// WEBPACK FOOTER //
// ./src/state/actions.js